import React, { useState } from 'react';
import './Login.css';

interface LoginProps {
  onAdminLogin: (token: string) => void;
  onBrokerLogin: (broker: any, properties: any[]) => void;
}

const Login: React.FC<LoginProps> = ({ onAdminLogin, onBrokerLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password) return;

    setIsLoading(true);
    setError('');

    try {
      const adminResp = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });

      if (adminResp.ok) {
        const { token } = await adminResp.json();
        onAdminLogin(token);
        return;
      }

      const brokerResp = await fetch('/api/brokers/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });

      if (brokerResp.ok) {
        const data = await brokerResp.json();
        onBrokerLogin(data.broker, data.properties);
        return;
      }

      const err = await brokerResp.json().catch(() => ({}));
      throw new Error(err.error || 'Invalid credentials');
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>Ownrly CRE</h1>
          <p>Sign in to your account</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label htmlFor="login-username">Email</label>
            <input
              id="login-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="you@example.com"
              autoComplete="username"
              autoFocus
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button
            type="submit"
            className="login-submit-btn"
            disabled={isLoading || !username.trim() || !password}
          >
            {isLoading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <p className="login-hint">Admin and broker accounts use the same login.</p>
      </div>
    </div>
  );
};

export default Login;
